import React, { useEffect, useState } from 'react';
export const LiveViewers = () => {
  // Inicializar con un número aleatorio entre 47 y 89
  const [viewers, setViewers] = useState(Math.floor(Math.random() * (89 - 47 + 1)) + 47);
  useEffect(() => {
    // Actualizar cada 3 a 5 segundos
    const interval = setInterval(() => {
      setViewers(prev => {
        // Fluctuación aleatoria entre -3 y +3
        const change = Math.floor(Math.random() * 7) - 3;
        let next = prev + change;
        // Mantener los límites entre 47 y 89
        if (next < 47) next = 47;
        if (next > 89) next = 89;
        return next;
      });
    }, Math.floor(Math.random() * 2000) + 3000);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-[#0F2439] text-white/90 py-2 px-4 text-center text-xs sm:text-sm flex items-center justify-center border-t border-white/10" data-id="element-215">
      <span className="relative flex h-2.5 w-2.5 mr-2.5" data-id="element-216">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-217"></span>
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" data-id="element-218"></span>
      </span>
      <span className="font-medium" data-id="element-219">
        {viewers} personas están viendo esto ahora
      </span>
    </div>;
};